// extracted by css-extract-rspack-plugin
export default {"sound-button":"src-components-GroupSettingsDeviceList-GroupSettingsDeviceList-module__sound-button-jSerQx","soundButton":"src-components-GroupSettingsDeviceList-GroupSettingsDeviceList-module__sound-button-jSerQx","audio":"src-components-GroupSettingsDeviceList-GroupSettingsDeviceList-module__audio-kuxahg","error":"src-components-GroupSettingsDeviceList-GroupSettingsDeviceList-module__error-xKAk7q"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"sound-button\":\"src-components-GroupSettingsDeviceList-GroupSettingsDeviceList-module__sound-button-jSerQx\",\"soundButton\":\"src-components-GroupSettingsDeviceList-GroupSettingsDeviceList-module__sound-button-jSerQx\",\"audio\":\"src-components-GroupSettingsDeviceList-GroupSettingsDeviceList-module__audio-kuxahg\",\"error\":\"src-components-GroupSettingsDeviceList-GroupSettingsDeviceList-module__error-xKAk7q\"}";
        // 1772473572992
        var cssReload = require("../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  